import * as React from 'react';
import { Checkbox } from '../../Checkbox';
import { PickableLocationCheckbox } from './PickableLocationCheckbox';
import { BasicLocationPickerClientGroup } from './types';

type PickableClientGroupProps = {
    client: BasicLocationPickerClientGroup;
    selected: ReadonlyArray<string>;
    disabled: ReadonlyArray<string>;
    onChange: (selected: string[]) => void;
};

export const PickableClientGroup: React.FC<PickableClientGroupProps> = ({ client, disabled, onChange, selected }) => {
    /*
     * To save on some calculations and looping through data, let's calculate all these values
     * while rendering the location checkboxes.
     */
    let areAllLocationsChecked = true;
    let isAtLeastOneLocationChecked = false;
    let areAllLocationsDisabled = true;

    const children = client.items.map(location => {
        const isChecked = selected.includes(location.id);
        areAllLocationsChecked &&= isChecked;
        isAtLeastOneLocationChecked ||= isChecked;
        areAllLocationsDisabled &&= disabled.includes(location.id);
        return (
            <PickableLocationCheckbox
                disabled={disabled}
                item={location}
                key={location.id}
                selected={selected}
                style={{ paddingLeft: '8px' }}
                onChange={onChange}
            />
        );
    });
    return (
        <>
            <Checkbox
                checked={areAllLocationsChecked}
                disabled={areAllLocationsDisabled}
                indeterminate={isAtLeastOneLocationChecked && !areAllLocationsChecked}
                key={client.id}
                type="checkbox"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    if (event.target.checked) {
                        const locationIds = client.items
                            .filter(location => !disabled.includes(location.id) && !selected.includes(location.id))
                            .map(({ id }) => id);
                        onChange([...selected, ...locationIds]);
                    } else {
                        const locationIds = client.items.map(({ id }) => id);
                        onChange(selected.filter(id => !locationIds.includes(id)));
                    }
                }}
            >
                {client.title}
            </Checkbox>
            {children}
        </>
    );
};

PickableClientGroup.displayName = 'PickableClientGroup';
